import { SelectorPart } from '@fullstory/client-api';
import { cssEscapeIdent } from '@fullstory/selectors';

// Finds the last css class name or id in the supplied string.
export function getClassOrId(s: string): string {
  const tokens = s.split(/>| /);

  for (let i = tokens.length - 1; i >= 0; i--) {
    const tok = tokens[i]!;
    if (tok.indexOf('#') >= 0 || tok.indexOf('.') >= 0) {
      return tok;
    }
  }

  return s;
}

// Finds the last css class name or id in the supplied string.
export function getClassOrIdStruct(tokens: SelectorPart[], expand = false): string {
  const s = [];

  for (let i = tokens.length - 1; i >= 0; i--) {
    const tok = tokens[i]!;

    let part = '';
    if (tok.Tag) {
      part += cssEscapeIdent(tok.Tag);
    }
    if (tok.Id) {
      if (!expand) {
        s.unshift(`#${cssEscapeIdent(tok.Id)}`);
        break;
      } else {
        part += `#${cssEscapeIdent(tok.Id)}`;
      }
    }

    if (tok.Classes) {
      for (const clazz of tok.Classes) {
        part += `.${cssEscapeIdent(clazz)}`;
      }
    }

    if (tok.Attrs) {
      for (const attr in tok.Attrs) {
        const val = tok.Attrs[attr];
        part += `[${cssEscapeIdent(attr)}`;
        if (val) {
          part += `="${cssEscapeIdent(val)}"`;
        }
        part += ']';
      }
    }
    s.unshift(part);
  }

  return s.join(' ');
}
